export default __webpack_public_path__ + "static/media/logoGestdoc.6c8ba2ca.svg";